import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { Global } from '@emotion/react';
import { useState, useCallback } from 'react';
import root from 'react-shadow/emotion.esm';
import { AccordionProvider } from './context/AccordionContext';
import { RootLayoutProvider } from './context/RootLayoutContext';
import { customDivPreflight } from './css/customPreflight';
import { preflight } from './css/preflight';
const style = {
    width: '100%',
    height: '100%',
};
export function RootLayout(props) {
    const [rootRef, setRootRef] = useState(typeof document !== 'undefined' ? document.body : null);
    const ref = useCallback((node) => {
        if (node !== null) {
            setRootRef(node);
        }
    }, []);
    return (_jsxs(root.div, { style: { ...style, ...props.style }, children: [_jsx(Global, { styles: preflight }), _jsx("div", { ref: ref, css: customDivPreflight, style: { width: '100%', height: '100%', position: 'relative' }, children: _jsx(RootLayoutProvider, { innerRef: rootRef, children: _jsx(AccordionProvider, { children: props.children }) }) })] }));
}
//# sourceMappingURL=RootLayout.js.map